
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c1272d","d":"M175.08 42.77l-13-13a21 21 0 00-29.77 0l-95.71 95.8a21.14 21.14 0 00-6.11 13.33l-2 26.85a9.86 9.86 0 009.81 10.6h.73L66 174.39a21.08 21.08 0 0013.37-6.12l95.74-95.73a21.05 21.05 0 00-.03-29.77z"}}),_c('path',{attrs:{"fill":"#c1272d","d":"M71.19 140.79h-8.13a.29.29 0 01-.29-.3v-7.23A10.31 10.31 0 0053.31 123l71.22-71.22 28.58 28.58L81.48 152v-.9a10.31 10.31 0 00-10.29-10.31zM65.25 164.41l-10.14.73-15.4-15.39.76-10.11a11 11 0 012.91-6.64h9.09a.3.3 0 01.3.29v7.23a10.31 10.31 0 0010.29 10.3h8.13a.3.3 0 01.29.3v10.82a11 11 0 01-6.23 2.47zM168 65.47l-7.83 7.83-28.57-28.58 7.83-7.83a11 11 0 0115.63 0l12.95 13a11.06 11.06 0 01-.01 15.58z"}}),_c('path',{staticClass:"fill",attrs:{"fill":"#141414","d":"M175.08 42.77l-13-13a21 21 0 00-29.77 0l-95.71 95.8a21.14 21.14 0 00-6.11 13.33l-2 26.85a9.86 9.86 0 009.81 10.6h.73L66 174.39a21.08 21.08 0 0013.37-6.12l95.74-95.73a21.05 21.05 0 00-.03-29.77z"}}),_c('path',{attrs:{"fill":"#fff","d":"M71.19 140.79h-8.13a.29.29 0 01-.29-.3v-7.23A10.31 10.31 0 0053.31 123l71.22-71.22 28.58 28.58L81.48 152v-.9a10.31 10.31 0 00-10.29-10.31zM65.25 164.41l-10.14.73-15.4-15.39.76-10.11a11 11 0 012.91-6.64h9.09a.3.3 0 01.3.29v7.23a10.31 10.31 0 0010.29 10.3h8.13a.3.3 0 01.29.3v10.82a11 11 0 01-6.23 2.47zM168 65.47l-7.83 7.83-28.57-28.58 7.83-7.83a11 11 0 0115.63 0l12.95 13a11.06 11.06 0 01-.01 15.58z"}})])
          )
        }
      }
    